import { all, call, fork, put, select, takeEvery } from "@redux-saga/core/effects";
import { GET_CONTACT } from "../../constants/ActionTypes";
import { getData } from "../../util/DynamicApi";
import { clearToken, getContactSuccess } from "../actions";
import { ShowError } from "../../util/MessageHelper";

const getContactRequest = async (token) =>
  await getData(token, "Contact", null)
    .then((contact) => {
      console.log(contact);
      return contact;
    })
    .catch((error) => {
      return error.response.data;
    });

export const getToken = ({ auth }) => auth.token;

function* doGetContact() {
  try {
    let token = yield select(getToken);
    const contact = yield call(getContactRequest, token);
    if (contact.errorMessage) {

      if (
        contact.errorMessage === "LogOut" ||
        contact.errorMessage === "401") {
        
         
         /*  localStorage.removeItem("user_id");
          localStorage.removeItem("token"); */
          ShowError('پایان نشست','مجددا وارد شوید');
        
        //yield put(clearToken());
      }
      // yield put(showAuthMessage(signInUser.message));
    } else {
      yield put(getContactSuccess(contact.data.data));
      console.info(contact.data.data);
    }
  } catch (error) {
    //yield put(showAuthMessage(error));
  }
}

export function* getContactUser() {
  yield takeEvery(GET_CONTACT, doGetContact);
}
export default function* rootSaga() {
  yield all([fork(getContactUser)]);
}
